export default () => {
	const popup = document.querySelector('.cart-add');
	const VISIBLE_CLASS = 'cart-add--visible';

	if (popup) {
		document.body.appendChild(popup);
		let closeBtn = popup.querySelector('.js-close-add');
		closeBtn.addEventListener('click', () => {
			popup.classList.remove(VISIBLE_CLASS);
			document.body.classList.remove('is-cart-add-visible');
		});
	}
}